import { render, staticRenderFns } from "./configWelcome.vue?vue&type=template&id=5c4330b9&scoped=true&"
import script from "./configWelcome.vue?vue&type=script&lang=js&"
export * from "./configWelcome.vue?vue&type=script&lang=js&"
import style0 from "./configWelcome.vue?vue&type=style&index=0&id=5c4330b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4330b9",
  null
  
)

export default component.exports